function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 3l3.59 3.59M21 21l-3.589-3.589m-3.536 1.414c-.607.115-1.234.175-1.874.175-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.564-3.029m5.857.908a3 3 0 114.243 4.243M9.879 9.878l4.243 4.242M9.879 9.88l-3.29-3.29m7.533 7.532L6.589 6.59m7.533 7.532l3.29 3.29M6.588 6.59A9.953 9.953 0 0112.001 5c4.477 0 8.268 2.943 9.542 7a10.024 10.024 0 01-4.132 5.411",
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "/img/eye-off.svg";
export { SvgEyeOff as ReactComponent };